// extracted by mini-css-extract-plugin
export default {"SkeletonRectangle":"SkeletonRectangle_SkeletonRectangle__lPoac","shine":"SkeletonRectangle_shine__25sHE"};